import {createAction} from '@reduxjs/toolkit'
import {isMobile} from '../../../../commons/selectors/environment'
import {isCalendarLayout, isMobileDailyListLayout} from '../selectors/list-settings'
import {getComponentConfig, getValue} from '../selectors/settings'
import {createAsyncAction} from '../services/redux-toolkit'
import {State} from '../types/state'
import {closeMonthlyCalendarPopup, openAnyEventDetails} from './calendar-layout'
import {reloadEvents} from './events'

interface StyleParams {
  numbers: Record<string, number>
  booleans: Record<string, boolean>
}

export const updateStyleParams = createAction<Record<string, number | boolean>>('UPDATE_STYLE_PARAMS')

export const updateStyles = createAsyncAction<void, StyleParams>(
  'UPDATE_STYLES',
  async (params, {dispatch, getState, extra: {flowAPI}}) => {
    const layoutChanging = isLayoutChanging(getState(), params)

    await dispatch(
      updateStyleParams({
        ...params.numbers,
        ...params.booleans,
      }),
    )

    if (layoutChanging) {
      dispatch(closeMonthlyCalendarPopup())
      await dispatch(reloadEvents())

      const state = getState()
      const mobile = isMobile(state)
      const componentConfig = getComponentConfig(state)

      if (
        !flowAPI.environment.isEditorX &&
        (mobile ? isMobileDailyListLayout(componentConfig) : isCalendarLayout(componentConfig))
      ) {
        dispatch(openAnyEventDetails())
      }
    }
  },
)

const isLayoutChanging = (state: State, params: StyleParams) => {
  const {settings} = getComponentConfig(state)
  const updatedSettings = {...settings, ...params.numbers}
  const {listLayout, widgetLayout, recurringFilter} = settings
  const {
    listLayout: updatedListLayout,
    widgetLayout: updatedWidgetLayout,
    recurringFilter: updatedRecurringFilter,
  } = updatedSettings

  const isParamChanging = (newValue, oldValue) => newValue !== undefined && oldValue !== newValue

  if (isMobile(state)) {
    const mobileWidgetLayoutNew = getValue(settings, true, 'mobileWidgetLayoutNew')
    const updatedMobileWidgetLayoutNew = getValue(updatedSettings, true, 'mobileWidgetLayoutNew')
    const mobileWidgetListLayoutType = getValue(settings, true, 'mobileWidgetListLayoutType')
    const updatedMobileWidgetListLayoutType = getValue(updatedSettings, true, 'mobileWidgetListLayoutType')

    return (
      isParamChanging(updatedMobileWidgetLayoutNew, mobileWidgetLayoutNew) ||
      isParamChanging(updatedMobileWidgetListLayoutType, mobileWidgetListLayoutType)
    )
  } else {
    return (
      isParamChanging(updatedListLayout, listLayout) ||
      isParamChanging(updatedWidgetLayout, widgetLayout) ||
      isParamChanging(updatedRecurringFilter, recurringFilter)
    )
  }
}
